import { UntypedFormControl, Validators } from '@angular/forms';

export class CustomValidators extends Validators {
  static isObject(control: UntypedFormControl) {
    if (isNaN(control.value) && typeof control.value !== 'object') {
      return { notAnObject: true };
    } else {
      return null;
    }
  }

  static isEmailValid(control: UntypedFormControl) {
    let emailFormat = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

    if (control.value != '' && !control.value.match(emailFormat)) {
      return { invalidEmail: true };
    } else {
      return null;
    }
  }
}
